// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"c2bbfc80","322":"a6f979df","393":"696549df","453":"8ab44547","605":"ee4b633f","883":"4ff4f3e5","949":"cc72b552"}[chunkId] + ".chunk.js";
};